namespace PaperTrail.NewsletterControl {
    export interface InviteContributorsRequest extends Serenity.ServiceRequest {
        Inviter?: string;
        Invitees?: string[];
        SubscriptionID?: number;
        SubscriptionName?: string;
        NewsletterID?: number;
        NewsletterName?: string;
        Comments?: string;
    }
}
